import { connect } from "react-redux";
import * as thunkActions from "../actions/thunks";
import * as datesThunkActions from "../../../SideRight/Dates/actions/thunks";
import { closeModalAsThunk, clearUpdateTransactionMlsDataAsThunk } from "../../../Header/actions/thunks";
import {
  setUpdateTransactionModalOpen,
  setStatusLoading,
  setConnectedService,
  setConnectServicesError,
} from "../../../Header/actions/creators";
import { financialsSetClosedPrice } from "../../Financials/actions/creators";
import { fetchFinancials } from "../../Financials/actions/thunks";
import { setRefStatus } from "../actions/creators";
import { getAllPeopleAsThunk } from "../../../SideLeft/People/actions/thunks";
import UpdateTransactionModal from "./UpdateTransactionModal";

const mapStateToProps = (state) => ({
  isUpdateTransactionModalOpen: state.tdpDetailsReducer.isUpdateTransactionModalOpen,
  updateTransactionMlsData: state.tdpDetailsReducer.updateTransactionMlsData,
  propertyDetails: state.tdpDetailsReducer.propertyDetails,
  listingDetailsData: state.tdpDetailsReducer.listingDetails,
  transactionDetails: state.tdpDetailsReducer.transactionDetails,
  accountSources: state.tdpDetailsReducer.meta.accountSources,
  accountPropertyTypes: state.tdpDetailsReducer.meta.accountPropertyTypes,
  mutualAcceptanceDateMilestone: state.tdpDatesReducer.dates.mutual_acceptance_date_milestone,
  closeDateMilestone: state.tdpDatesReducer.dates.close_date_milestone,
  uuid: state.tdpDetailsReducer.uuid,
  preStatus: state.tdpDetailsReducer.preStatus,
  closePriceVal: state.tdpFinancialsReducer.financials?.adaptedData?.transaction?.actual?.closePrice?.value,
  headerClosePriceVal: state.tdpFinancialsReducer.closedPrice,
  clients: state.tdpPeopleReducer.people?.listing_clients,
  transactionType: state.tdpDetailsReducer.headerDetails?.type,
  connectedService: state.tdpDetailsReducer.connectedService,
  clientRoles: state.tdpPeopleReducer.completeRoleList || [],
});

const mapDispatchToProps = (dispatch) => ({
  putDetailAsThunk: (payload) => dispatch(thunkActions.putDetailAsThunk(payload)),
  updateDateAsThunk: (uuid, optionId, data) => dispatch(datesThunkActions.updateDate(uuid, optionId, data)),
  closeModalAsThunk: (preStatus) => dispatch(closeModalAsThunk(preStatus)),
  closeUpdateTransactionModal: () => dispatch(setUpdateTransactionModalOpen(false, null)),
  clearUpdateTransactionMlsData: () => dispatch(clearUpdateTransactionMlsDataAsThunk()),
  setClosedPrice: (closedPrice) => dispatch(financialsSetClosedPrice(closedPrice)),
  fetchFinancials: () => dispatch(fetchFinancials()),
  stopStatusLoading: () => dispatch(setStatusLoading(false)),
  revertStatus: (_uuid, status) => {
    dispatch(setRefStatus(status));
    dispatch(setStatusLoading(false));
  },
  setConnectedService: (connectedService) => dispatch(setConnectedService(connectedService)),
  setConnectServicesError: (hasError) => dispatch(setConnectServicesError(hasError)),
  refreshPeople: (uuid) => dispatch(getAllPeopleAsThunk(uuid)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  refreshPeople: () => dispatchProps.refreshPeople(stateProps.uuid),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(UpdateTransactionModal);
